export * from './src/service-fees-v1-rule-service-fees.meta.js';
